module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C135"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "C146"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/05_PROLOGUE#page_vii"
    }
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_INTRODUCTION__My_Brain_in_a_Dish#page_1"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "C144a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_INTRODUCTION__My_Brain_in_a_Dish#page_1"
    }
  }, [_vm._v("My Brain in a Dish")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_CHAPTER_1__Pieces_of_Life__Cells#page_10"
    }
  }, [_vm._v("CHAPTER 1")])]), _vm._v(" "), _c('p', {
    staticClass: "C128a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_CHAPTER_1__Pieces_of_Life__Cells#page_10"
    }
  }, [_vm._v("Pieces of Life")])]), _vm._v(" "), _c('p', {
    staticClass: "C144a"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/07_CHAPTER_1__Pieces_of_Life__Cells#page_10"
    }
  }, [_vm._v("Cells past and present")])])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_CHAPTER_2__Body_Building__Growin#page_45"
    }
  }, [_vm._v("CHAPTER 2")])]), _vm._v(" "), _c('p', {
    staticClass: "C128a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_CHAPTER_2__Body_Building__Growin#page_45"
    }
  }, [_vm._v("Body Building")])]), _vm._v(" "), _c('p', {
    staticClass: "C144a"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/08_CHAPTER_2__Body_Building__Growin#page_45"
    }
  }, [_vm._v("Growing humans the old-fashioned way")])])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_FIRST_INTERLUDE__The_Human_Super#page_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIRST INTERLUDE")])]), _vm._v(" "), _c('p', {
    staticClass: "C128a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_FIRST_INTERLUDE__The_Human_Super#page_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Human Superorganism")])]), _vm._v(" "), _c('p', {
    staticClass: "C144a"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/09_FIRST_INTERLUDE__The_Human_Super#page_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How cells became communities")])])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_CHAPTER_3__Immortal_Flesh__How_t#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3")])]), _vm._v(" "), _c('p', {
    staticClass: "C128a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_CHAPTER_3__Immortal_Flesh__How_t#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Immortal Flesh")])]), _vm._v(" "), _c('p', {
    staticClass: "C144a"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/10_CHAPTER_3__Immortal_Flesh__How_t#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How tissues were grown outside the body")])])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_SECOND_INTERLUDE__Heroes_and_Vil#page_127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SECOND INTERLUDE")])]), _vm._v(" "), _c('p', {
    staticClass: "C128a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_SECOND_INTERLUDE__Heroes_and_Vil#page_127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heroes and Villains")])]), _vm._v(" "), _c('p', {
    staticClass: "C144a"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/11_SECOND_INTERLUDE__Heroes_and_Vil#page_127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cancer, immunity and our cellular ecosystem")])])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_CHAPTER_4__Twists_of_Fate__How_t#page_143",
      "id": "page_vi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4")])]), _vm._v(" "), _c('p', {
    staticClass: "C128a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_CHAPTER_4__Twists_of_Fate__How_t#page_143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twists of Fate")])]), _vm._v(" "), _c('p', {
    staticClass: "C144a"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/12_CHAPTER_4__Twists_of_Fate__How_t#page_143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to reprogramme a cell")])])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_CHAPTER_5__The_Spare_Parts_Facto#page_184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5")])]), _vm._v(" "), _c('p', {
    staticClass: "C128a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_CHAPTER_5__The_Spare_Parts_Facto#page_184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Spare Parts Factory")])]), _vm._v(" "), _c('p', {
    staticClass: "C144a"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/13_CHAPTER_5__The_Spare_Parts_Facto#page_184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making tissues and organs from reprogrammed cells")])])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_CHAPTER_6__Flesh_of_My_Flesh__Qu#page_209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6")])]), _vm._v(" "), _c('p', {
    staticClass: "C128a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_CHAPTER_6__Flesh_of_My_Flesh__Qu#page_209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flesh of My Flesh")])]), _vm._v(" "), _c('p', {
    staticClass: "C144a"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/14_CHAPTER_6__Flesh_of_My_Flesh__Qu#page_209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Questioning the future of sex and reproduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_CHAPTER_7__Hideous_Progeny___The#page_247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7")])]), _vm._v(" "), _c('p', {
    staticClass: "C128a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_CHAPTER_7__Hideous_Progeny___The#page_247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hideous Progeny?")])]), _vm._v(" "), _c('p', {
    staticClass: "C144a"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/15_CHAPTER_7__Hideous_Progeny___The#page_247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The futures of growing humans")])])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_THIRD_INTERLUDE__Philosophy_of_t#page_299",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THIRD INTERLUDE")])]), _vm._v(" "), _c('p', {
    staticClass: "C128a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_THIRD_INTERLUDE__Philosophy_of_t#page_299",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philosophy of the Lonely Mind")])]), _vm._v(" "), _c('p', {
    staticClass: "C144a"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/16_THIRD_INTERLUDE__Philosophy_of_t#page_299",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Can a brain exist in a dish?")])])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_CHAPTER_8__Return_of_the_Meatwar#page_316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8")])]), _vm._v(" "), _c('p', {
    staticClass: "C128a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_CHAPTER_8__Return_of_the_Meatwar#page_316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Return of the Meatware")])]), _vm._v(" "), _c('p', {
    staticClass: "C146a"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/17_CHAPTER_8__Return_of_the_Meatwar#page_316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coming to terms with our fleshy selves")])])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_ACKNOWLEDGEMENTS#page_331",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_ENDNOTES#page_333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_BIBLIOGRAPHY#page_341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BIBLIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_PICTURE_CREDITS#page_355",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PICTURE CREDITS")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/22_INDEX#page_357",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-180e9b34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_CONTENTS.vue
// module id = 63
// module chunks = 0